<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/As7MAK/tc-custom/9781540260178.jpg?1719575726355" alt="This image is the cover for the book Hidden History of the Dark Corner, Hidden History"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Hidden History of the Dark Corner, Hidden History
      </h1>
      <p class="bookDescription body article font2">
        <p>The Dark in the Dark Corner Years ago, when travelers to northern Greenville County asked a local where the Dark Corner was, invariably their reply was, "Just a little further up the road." In those days few people wanted to admit they lived in that much storied and much maligned part of the county known as the Dark Corner. The Dark Corner in those days was legendary for its moonshine, murder and mayhem. This is the story of that well-known region. We travel back to the Dark Corner's earliest days when its only human inhabitants were the Cherokee, and we move into the present where horse farms and multi-million-dollar homes dot the countryside that once contained moonshine stills and cornfields.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mr. Drew Hines
      </h2>
      
      <p class="authorDescription body article">Drew Hines is a native of Greensboro, North Carolina, but has spent most of his life in the Upstate of South Carolina. A Baptist minister for forty-three years, he's now retired and enjoys writing, gardening and traveling. He has been married for forty-seven years to Suzanne, and they have two adult children and five grandchildren. He is a graduate of the University of South Carolina and is the recipient of two postgraduate degrees from the Southern Baptist Theological Seminary in Louisville, Kentucky. He is the author of two other books: In Mountain Shadows and North of Jordan . He also writes a column on local and regional history for the Tryon Daily Bulletin in Tryon, North Carolina.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?599b9eff